import { Button } from "components/DesignSystem/Button/Button";
import { PlayIcon } from "components/icons/PlayIcon";
import { PLATFORM_TOUR_WATCH_CLICKED } from "constants/analyticsEvents";
import { PLATFORM_TOUR_SOURCE } from "constants/productTour";
import { useAnalytics } from "hooks/useAnalytics";
import { useAppDispatch } from "hooks/useAppDispatch";
import { openPlatformTourPlayer } from "store/slices/platformTour";

type PlatformTourHelpItemProps = {
  onSelect: () => void;
};

export const PlatformTourHelpItem = ({
  onSelect,
}: PlatformTourHelpItemProps) => {
  const dispatch = useAppDispatch();
  const { trackEvent } = useAnalytics();

  const handleClick = () => {
    trackEvent(PLATFORM_TOUR_WATCH_CLICKED, {
      source: PLATFORM_TOUR_SOURCE.GET_HELP,
    });
    onSelect();
    dispatch(openPlatformTourPlayer(PLATFORM_TOUR_SOURCE.GET_HELP));
  };

  return (
    <Button
      type="button"
      customType="ghost"
      onClick={handleClick}
      leftIcon={
        <span className="t-flex t-size-4 t-items-center t-justify-center t-rounded-full t-bg-purple-40 t-text-white">
          <PlayIcon width={9} height={9} />
        </span>
      }
      className="!t-w-full !t-justify-start !t-items-center !t-rounded-lg !t-border !t-border-solid !t-border-purple-10 !t-bg-purple-0 !t-p-3  hover:!t-bg-purple-10"
    >
      <span className="!t-text-body-sm t-text-text-60">
        Explore Inkle Tax Platform
      </span>
    </Button>
  );
};
